module.exports = __webpack_public_path__ + "files/ca51c87528eae63e2fbc2227d320a751.png";